import { useState } from "react";

import CafePage1 from "./Cafe/CafePage1";
import CafePage2 from "./Cafe/CafePage2";
import CafePage3 from "./Cafe/CafePage3";
import CafePage4 from "./Cafe/CafePage4";
import CleaningPage1 from "./Cleaning/CleaningPage1";
import CleaningPage2 from "./Cleaning/CleaningPage2";
import CleaningPage3 from "./Cleaning/CleaningPage3";
import CleaningPage4 from "./Cleaning/CleaningPage4";
import DinnerPage1 from "./Dinner/DinnerPage1";
import DinnerPage2 from "./Dinner/DinnerPage2";
import DinnerPage3 from "./Dinner/DinnerPage3";
import DinnerPage4 from "./Dinner/DinnerPage4";
import LunchPage1 from "./Lunch/LunchPage1";
import LunchPage2 from "./Lunch/LunchPage2";
import LunchPage3 from "./Lunch/LunchPage3";
import LunchPage5 from "./Lunch/LunchPage5";
import LunchPage4 from "./Lunch/LunchPage4";
import MarketPage1 from "./Market/MarketPage1";
import MarketPage2 from "./Market/MarketPage2";
import MarketPage3 from "./Market/MarketPage3";
import MarketPage4 from "./Market/MarketPage4";
import MarketPage5 from "./Market/MarketPage5";
import MarketPage6 from "./Market/MarketPage6";
import MarketPage7 from "./Market/MarketPage7";
import WeekendPage from "./Weekend/WeekendPage";
import ClothesPage1 from "./Clothes/ClothesPage1";
import ClothesPage2 from "./Clothes/ClothesPage2";
import ClothesPage3 from "./Clothes/ClothesPage3";
import ClothesPage4 from "./Clothes/ClothesPage4";
import EndingPage from "./Ending/EndingPage";

const GamePage = () => {
  const [garbageQtty, setGarbageQtty] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  let page;

  switch (currentPage) {
    case "cafe-1":
      page = <CafePage1 setCurrentPage={setCurrentPage} />;
      break;
    case "cafe-2":
      page = (
        <CafePage2
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "cafe-3":
      page = <CafePage3 setCurrentPage={setCurrentPage} />;
      break;
    case "cafe-4":
      page = <CafePage4 setCurrentPage={setCurrentPage} />;
      break;
    case "lunch-1":
      page = <LunchPage1 setCurrentPage={setCurrentPage} />;
      break;
    case "lunch-2":
      page = <LunchPage2 setCurrentPage={setCurrentPage} />;
      break;
    case "lunch-3":
      page = (
        <LunchPage3
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "lunch-4":
      page = <LunchPage4 setCurrentPage={setCurrentPage} />;
      break;
    case "lunch-5":
      page = <LunchPage5 setCurrentPage={setCurrentPage} />;
      break;
    case "dinner-1":
      page = <DinnerPage1 setCurrentPage={setCurrentPage} />;
      break;
    case "dinner-2":
      page = (
        <DinnerPage2
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "dinner-3":
      page = <DinnerPage3 setCurrentPage={setCurrentPage} />;
      break;
    case "dinner-4":
      page = <DinnerPage4 setCurrentPage={setCurrentPage} />;
      break;
    case "cleaning-1":
      page = <CleaningPage1 setCurrentPage={setCurrentPage} />;
      break;
    case "cleaning-2":
      page = (
        <CleaningPage2
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "cleaning-3":
      page = <CleaningPage3 setCurrentPage={setCurrentPage} />;
      break;
    case "cleaning-4":
      page = <CleaningPage4 setCurrentPage={setCurrentPage} />;
      break;
    case "market-1":
      page = <MarketPage1 setCurrentPage={setCurrentPage} />;
      break;
    case "market-2":
      page = (
        <MarketPage2
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "market-3":
      page = <MarketPage3 setCurrentPage={setCurrentPage} />;
      break;
    case "market-4":
      page = <MarketPage4 setCurrentPage={setCurrentPage} />;
      break;
    case "market-5":
      page = (
        <MarketPage5
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "market-6":
      page = <MarketPage6 setCurrentPage={setCurrentPage} />;
      break;
    case "market-7":
      page = <MarketPage7 setCurrentPage={setCurrentPage} />;
      break;
    case "weekend":
      page = <WeekendPage setCurrentPage={setCurrentPage} />;
      break;
    case "clothes-1":
      page = <ClothesPage1 setCurrentPage={setCurrentPage} />;
      break;
    case "clothes-2":
      page = (
        <ClothesPage2
          setCurrentPage={setCurrentPage}
          setGarbageQtty={setGarbageQtty}
        />
      );
      break;
    case "clothes-3":
      page = <ClothesPage3 setCurrentPage={setCurrentPage} />;
      break;
    case "clothes-4":
      page = <ClothesPage4 setCurrentPage={setCurrentPage} />;
      break;
    case "ending":
      page = <EndingPage garbageQtty={garbageQtty} />;
      break;
    default:
      page = <CafePage1 setCurrentPage={setCurrentPage} />;
  }

  return page;
};

export default GamePage;
